<template>
  <div class="dutyAreaPage">
    <div class="titInfo" v-if="titShow">
      <p>
        {{ nName ? nName + "--" : "" }} {{ tName ? tName + "--" : ""
        }}{{ uName ? uName + "--" : "" }}{{ lName ? lName + "--" : ""
        }}{{ iName ? iName : "" }}
      </p>
    </div>
    <div class="forestMap">
      <!-- 地图页 -->
      <map-locator :param="mapData" mode="h5"></map-locator>
    </div>
    <div :class="[titShow ? 'TitForestTab' : 'noneTitForestTab', 'forestTab']">
      <van-tabs v-model="activeName">
        <van-tab title="责任区信息" name="dutyAreatMsg" class="baseMsg">
          <duty-area-msg :dataInfo="paramData"></duty-area-msg>
        </van-tab>
        <van-tab title="资源信息" name="dutyMsg" class="baseMsg">
          <pub-resource :dataInfo="paramData"></pub-resource>
        </van-tab>
        <!-- <van-tab
          v-for="(item, index) in msgList"
          :key="item.id"
          :title="item.postName"
          :name="'dutyArea' + index"
          class="baseMsg"
        >
          <duty-area-policy :dataInfo="item"></duty-area-policy>
        </van-tab> -->
        <van-tab
          title="电子公示牌"
          name="dutyAreaPublicity"
          class="dutyAreaPublicity"
        >
          <duty-area-publicity :dataInfo="paramData"></duty-area-publicity>
        </van-tab>
        <van-tab title="群众建议" name="massesAdvise" class="baseMsg">
          <area-advise :dataInfo="paramData"></area-advise>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
const mapLocator = () => import("@/views/pub/components/pubMapLocator");
const refreshPage = () => import("@/components/common/refreshPage");
const dutyAreaMsg = () => import("@/views/pub/components/zrqAreaMsg");
const dutyAreaPolicy = () => import("@/views/pub/components/areaPolicy");
const pubResource = () => import("@/views/pub/components/pubResource");
const areaAdvise = () => import("@/views/pub/components/massesAdvise");
const dutyAreaPublicity = () =>
  import("@/views/pub/components/commonPublicity");
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "pubResourceMsg",
  data() {
    return {
      dutyAreaId: "", //objId
      gridLevel: "", //责任区等级
      gridType: "", //责任区类型
      gridZqcode: "",
      mapData: {
        type: "",
        objid: "",
      },
      paramData: {
        objid: "",
        level: "",
        zqCode: "",
        type: "",
        areaType:'zrq'
      },
      interiorPoint: "",
      msgList: [], //根据责任区|政区获取文本信息list
      activeName: "dutyAreatMsg", //默认选中第一项
      tName: "",
      uName: "",
      lName: "",
      nName: "",
      iName: "",
      clientType: "", //手机类型
      titShow: false,
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  components: {
    dutyAreaMsg,
    pubResource,
    dutyAreaPublicity,
    dutyAreaPolicy,
    mapLocator,
    areaAdvise,
  },
  mounted() {
    document.title = "资源信息";
    // _T: 类型;
    // _U: 标识码;
    // _L: 坐标;
    // _N: 标题;
    // _I: 内容;
    this.tName = this.$route.query._T;
    this.uName = this.$route.query._U;
    this.lName = this.$route.query._L;
    this.nName = this.$route.query._N;
    this.iName = this.$route.query._I;
    this.clientType = getDeviceType();
    this.titShow =
      (this.tName || this.uName || this.lName || this.nName || this.iName) !=
        "" &&
      (this.tName || this.uName || this.lName || this.nName || this.iName) !=
        undefined
        ? true
        : false;
    console.log(this.titShow, " this.titShow");
    this.$nextTick(function () {
      this.dutyAreaId = this.$route.query.commonId;
      this.gridLevel = this.$route.query.zqLevel;
      this.gridZqcode = this.$route.query.zqCode;
      this.mapData.type = this.getGridType(this.gridLevel);
      this.mapData.objid = this.$route.query.commonId;

      this.getGridArchives(
        this.getGridType(this.gridLevel),
        this.gridLevel,
        this.dutyAreaId,
        this.gridZqcode
      );
      this.paramData.objid = this.dutyAreaId;
      this.paramData.level = this.gridLevel;
      this.paramData.zqCode = this.gridZqcode;
      this.paramData.type = this.getGridType(this.gridLevel);

      console.log(this.mapData);
    });
  },
  methods: {
    getLevel(type) {
      //获取责任区等级
      let grade = "";
      if (type == "geo_grid_sheng" || type == "geo_sheng") {
        grade = "1";
      } else if (type == "geo_grid_shi" || type == "geo_shi") {
        grade = "2";
      } else if (type == "geo_grid_xian" || type == "geo_xian") {
        grade = "3";
      } else if (type == "geo_grid_xiang" || type == "geo_xiang") {
        grade = "4";
      } else {
        grade = "5";
      }
      return grade;
    },
    getGridType(grid) {
      let type = "";
      if (grid == "1") {
        type = "geo_grid_sheng";
      } else if (grid == "2") {
        type = "geo_grid_shi";
      } else if (grid == "3") {
        type = "geo_grid_xian";
      } else if (grid == "4") {
        type = "geo_grid_xiang";
      } else {
        type = "geo_grid_cun";
      }
      return type;
    },
    getGridArchives(type, level, objid, zqCode) {
      let _this = this;
      _this.$api.pubZrq
        .getGridArchives({
          type: type,
          level: level,
          objid: objid,
          zqCode: "",
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.msgList = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    param: {
      handler: function () {
        let _this = this;

        this.paramData.objid = this.param.id;
        this.paramData.level = this.getLevel(this.param.type);
        this.paramData.zqCode = this.param.zqCode;
        this.paramData.type = this.param.type;
        this.getGridArchives(
          this.param.type,
          this.getLevel(this.param.type),
          this.param.id,
          this.param.zqCode
        );
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.dutyAreaPage {
  width: 100%;
  height: 100%;
  .titInfo {
    width: 100%;
    padding: 0 16px;
    p {
      line-height: 20px;
      padding-top: 10px;
      font-size: 14px;
    }
    margin-bottom: 10px;
  }
  .forestMap {
    width: 100%;
    height: 40%;
    > div {
      height: 100%;
    }
  }
  .TitForestTab {
    height: calc(60% - 65px);
  }
  .noneTitForestTab {
    height: 60%;
  }
  .forestTab {
    width: 100%;

    .van-tabs {
      height: 100%;
      overflow: hidden;

      .van-tabs__line {
        background-color: #4bc08a;
      }

      .van-tab--active {
        .van-tab__text {
          color: #4bc08a;
        }
      }

      .van-tabs__wrap {
        height: 45px;
      }

      .van-tabs__content {
        width: 100%;
        height:calc(100% - 45px);
        // overflow-y: scroll;

        .van-tab__pane {
          width: 100%;
        }

        .baseMsg.van-tab__pane,
        .dutyAreaEvaluate.van-tab__pane,
        .dutyAreaPublicity.van-tab__pane,
        .dutyAreaPolicy.van-tab__pane,
        .massesAdvise.van-tab__pane {
          height: 100%;
          background-color: #f6f6f6;
        }
      }
    }
  }
  .forestTab.SmallTab {
    height: 100%;
  }
}
</style>